import { useQuery } from '@apollo/client';
import { GET_LIST_OPTIONS_FOR_ALLERGIES_AND_OTHERS } from '../../services/graphql/queries/common';

export default function useListOptionsForAllergiesAndOthers() {
  const { data, loading, refetch } = useQuery(GET_LIST_OPTIONS_FOR_ALLERGIES_AND_OTHERS);

  return {
    data: data?.listOptionsForAllergiesAndOthers,
    loading,
    refetch
  };
}